import { render, staticRenderFns } from "./mallProvider.vue?vue&type=template&id=37d23958&scoped=true&"
import script from "./mallProvider.vue?vue&type=script&lang=js&"
export * from "./mallProvider.vue?vue&type=script&lang=js&"
import style0 from "./mallProvider.vue?vue&type=style&index=0&id=37d23958&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d23958",
  null
  
)

export default component.exports